import styled from 'styled-components';

export const OnboardingWrapper = styled.div`
`;
